/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_ReaderInputs */

const en_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Reader`)
};

const es_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir lector`)
};

const fr_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la liseuse`)
};

const de_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader öffnen`)
};

const ja_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リーダーを開く`)
};

const zh_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开阅读器`)
};

const ar_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح القارئ`)
};

const id_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka Pembaca`)
};

const it_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri Lettore`)
};

const ru_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть ридер`)
};

const pt_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Leitor`)
};

const ko_open_reader = /** @type {(inputs: Open_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리더 열기`)
};

/**
* | output |
* | --- |
* | "Open Reader" |
*
* @param {Open_ReaderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const open_reader = /** @type {((inputs?: Open_ReaderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_ReaderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_open_reader(inputs)
	if (locale === "es") return es_open_reader(inputs)
	if (locale === "fr") return fr_open_reader(inputs)
	if (locale === "de") return de_open_reader(inputs)
	if (locale === "ja") return ja_open_reader(inputs)
	if (locale === "zh") return zh_open_reader(inputs)
	if (locale === "ar") return ar_open_reader(inputs)
	if (locale === "id") return id_open_reader(inputs)
	if (locale === "it") return it_open_reader(inputs)
	if (locale === "ru") return ru_open_reader(inputs)
	if (locale === "pt") return pt_open_reader(inputs)
	return ko_open_reader(inputs)
});